import { fetchApi } from '@/services/api-client';

export type MedicalTag = {
  id: string;
  label: string;
  color: string;
  sortOrder: number;
  active: boolean;
};

export type MedicalTagInput = { label: string; color?: string; sortOrder?: number; active?: boolean };

export const medicalTagsApi = {
  list: () => fetchApi<MedicalTag[]>('/medical/tags'),
  create: (data: MedicalTagInput) =>
    fetchApi<MedicalTag>('/medical/tags', { method: 'POST', body: JSON.stringify(data) }),
  update: (id: string, data: Partial<MedicalTagInput>) =>
    fetchApi<MedicalTag>(`/medical/tags/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),
  remove: (id: string) => fetchApi<{ success: true }>(`/medical/tags/${id}`, { method: 'DELETE' }),
};
